// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 40px 24px 80px;
}

.legal-page .legal-header {
    text-align: center;
    margin-bottom: 40px;
    padding-bottom: 24px;
    border-bottom: 2px solid #e0e0e0;
}

.legal-page .legal-header .legal-logo {
    display: block;
    width: 110px;
    height: auto;
    margin: 0 auto 16px;
}

.legal-page .legal-header h1 {
    margin: 0 0 12px 0;
    color: #333;
    font-size: 32px;
    font-weight: 700;
}

.legal-page .legal-meta {
    color: #888;
    font-size: 14px;
}

.legal-page .legal-content {
    color: #333;
    font-size: 15px;
    line-height: 1.8;
}

.legal-page .legal-content h2 {
    color: #333;
    font-size: 22px;
    font-weight: 700;
    margin-top: 36px;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e9ecef;
}

.legal-page .legal-content h3 {
    color: #444;
    font-size: 18px;
    font-weight: 600;
    margin-top: 24px;
    margin-bottom: 12px;
}

.legal-page .legal-content p {
    margin-bottom: 14px;
    color: #444;
}

.legal-page .legal-content ul,
.legal-page .legal-content ol {
    margin-left: 24px;
    margin-bottom: 16px;
}

.legal-page .legal-content li {
    margin-bottom: 8px;
    color: #444;
}

.legal-page .legal-content a {
    color: #667eea;
    text-decoration: none;
}

.legal-page .legal-content a:hover {
    text-decoration: underline;
}

.legal-page .legal-section {
    margin-bottom: 32px;
}

.legal-page .back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 24px;
    color: #667eea;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: color 0.2s ease;
}

.legal-page .back-link:hover {
    color: #764ba2;
}

@media (max-width: 768px) {
    .legal-page {
        padding: 24px 16px 60px;
    }

    .legal-page .legal-header h1 {
        font-size: 26px;
    }

    .legal-page .legal-content {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/LegalPage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".legal-page {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 40px 24px 80px;\n}\n\n.legal-page .legal-header {\n    text-align: center;\n    margin-bottom: 40px;\n    padding-bottom: 24px;\n    border-bottom: 2px solid #e0e0e0;\n}\n\n.legal-page .legal-header .legal-logo {\n    display: block;\n    width: 110px;\n    height: auto;\n    margin: 0 auto 16px;\n}\n\n.legal-page .legal-header h1 {\n    margin: 0 0 12px 0;\n    color: #333;\n    font-size: 32px;\n    font-weight: 700;\n}\n\n.legal-page .legal-meta {\n    color: #888;\n    font-size: 14px;\n}\n\n.legal-page .legal-content {\n    color: #333;\n    font-size: 15px;\n    line-height: 1.8;\n}\n\n.legal-page .legal-content h2 {\n    color: #333;\n    font-size: 22px;\n    font-weight: 700;\n    margin-top: 36px;\n    margin-bottom: 16px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.legal-page .legal-content h3 {\n    color: #444;\n    font-size: 18px;\n    font-weight: 600;\n    margin-top: 24px;\n    margin-bottom: 12px;\n}\n\n.legal-page .legal-content p {\n    margin-bottom: 14px;\n    color: #444;\n}\n\n.legal-page .legal-content ul,\n.legal-page .legal-content ol {\n    margin-left: 24px;\n    margin-bottom: 16px;\n}\n\n.legal-page .legal-content li {\n    margin-bottom: 8px;\n    color: #444;\n}\n\n.legal-page .legal-content a {\n    color: #667eea;\n    text-decoration: none;\n}\n\n.legal-page .legal-content a:hover {\n    text-decoration: underline;\n}\n\n.legal-page .legal-section {\n    margin-bottom: 32px;\n}\n\n.legal-page .back-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 24px;\n    color: #667eea;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 500;\n    transition: color 0.2s ease;\n}\n\n.legal-page .back-link:hover {\n    color: #764ba2;\n}\n\n@media (max-width: 768px) {\n    .legal-page {\n        padding: 24px 16px 60px;\n    }\n\n    .legal-page .legal-header h1 {\n        font-size: 26px;\n    }\n\n    .legal-page .legal-content {\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
